import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentSetupService, usersService } from "services";
import { uiActions } from "store";
import { ErrorResponse, UpdateStatusProps } from "types";

type UseSetUserStatusMutationProps = {
	onSuccess?: Function;
	isAgent?: boolean;
};

const useSetUserStatusMutation = ({
	onSuccess,
	isAgent = false,
}: UseSetUserStatusMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, status }: UpdateStatusProps) => {
			const service = isAgent
				? agentSetupService.updateAgentStatus
				: usersService.updateUserStatus;

			return service({
				id,
				status,
			});
		},
		{
			onSuccess(_, data) {
				onSuccess?.(data?.status);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useSetUserStatusMutation;
